import { Box, CardTabs, Title, useUpdateQueryParams } from 'vopay';
import { FunctionComponent, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import AccountAndBilling from './AccountAndBilling';
import Invoices from './Invoices/Invoices';
import { useTranslation } from 'react-i18next';

type AccountBillingType = 'paymentMethods' | 'invoices';

type QueryParams = {
  type: string;
  currency: string;
  accountBillingType: AccountBillingType;
  searchTerm: string;
};

type FC = FunctionComponent;

const AccountAndBillingContainer: FC = () => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AccountAndBilling' });
  const location = useLocation();

  const queryParams: QueryParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      type: params.get('type') || '',
      currency: params.get('currency') || '',
      accountBillingType: (params.get('accountBillingType') as AccountBillingType) || 'paymentMethods',
      searchTerm: params.get('searchTerm') || '',
    };
  }, [location.search]);

  const activeTab = useMemo(() => queryParams.accountBillingType || '', [queryParams]);
  const updateQueryParams = useUpdateQueryParams<QueryParams>();

  function handleTabChange(value: string) {
    if (value === 'paymentMethods' || value === 'invoices') {
      updateQueryParams({
        accountBillingType: value,
        searchTerm: undefined,
        type: undefined,
        currency: undefined,
      });
    }
  }

  return (
    <>
      <Box jc="sb" flx="col" gapSize="36px">
        <Box jc="sb">
          <Title title={t('title')} />
        </Box>
        <Box flx="col" width="100%">
          <CardTabs.Root value={activeTab} onValueChange={handleTabChange}>
            <CardTabs.List aria-label="Account and Billing">
              <CardTabs.Trigger value="paymentMethods">{t('Tabs.paymentMethods')}</CardTabs.Trigger>
              <CardTabs.Trigger value="invoices">{t('Tabs.invoicesAndStatements')}</CardTabs.Trigger>
            </CardTabs.List>

            <CardTabs.Content value="paymentMethods">
              <AccountAndBilling />
            </CardTabs.Content>

            <CardTabs.Content value="invoices">
              <Invoices />
            </CardTabs.Content>
          </CardTabs.Root>
        </Box>
      </Box>
    </>
  );
};

export default AccountAndBillingContainer;
